// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","headerList":"Header_headerList__fHx-h","headerXs":"Header_headerXs__F36nX"};